var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179px",
    height: "27px",
    viewBox: "0 0 179 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 26.833 178.526 26.833 178.526 -3.55271368e-15 0 -3.55271368e-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-30.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Piper-Sandler-Logo",
    transform: "translate(30.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1881,8.0795 L3.1971,8.0795 L3.1971,12.5655 L6.1881,12.5655 C7.6381,12.5655 8.5581,11.6685 8.5581,10.3335 C8.5581,8.9995 7.6381,8.0795 6.1881,8.0795 M6.3491,15.4415 L3.1971,15.4415 L3.1971,21.6065 L0.0001,21.6065 L0.0001,5.2265 L6.3491,5.2265 C9.7541,5.2265 11.7561,7.5505 11.7561,10.3335 C11.7561,13.1175 9.7541,15.4415 6.3491,15.4415",
    id: "Fill-1",
    fill: "#4C4C4E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#4C4C4E",
    mask: "url(#mask-2)",
    points: "14.628 21.606 17.826 21.606 17.826 5.226 14.628 5.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3429,8.0795 L25.3529,8.0795 L25.3529,12.5655 L28.3429,12.5655 C29.7929,12.5655 30.7129,11.6685 30.7129,10.3335 C30.7129,8.9995 29.7929,8.0795 28.3429,8.0795 M28.5039,15.4415 L25.3529,15.4415 L25.3529,21.6065 L22.1549,21.6065 L22.1549,5.2265 L28.5039,5.2265 C31.9089,5.2265 33.9109,7.5505 33.9109,10.3335 C33.9109,13.1175 31.9089,15.4415 28.5039,15.4415",
    id: "Fill-5",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#4C4C4E",
    mask: "url(#mask-2)",
    points: "36.7819 21.6069 36.7819 5.2269 47.5719 5.2269 47.5719 8.0799 39.9799 8.0799 39.9799 11.9219 46.4449 11.9219 46.4449 14.7739 39.9799 14.7739 39.9799 18.7539 47.5719 18.7539 47.5719 21.6069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4215,8.0795 L54.4075,8.0795 L54.4075,12.4045 L57.4215,12.4045 C58.8245,12.4045 59.7455,11.5065 59.7455,10.2415 C59.7455,8.9765 58.8245,8.0795 57.4215,8.0795 L57.4215,8.0795 Z M59.9055,21.6065 L56.7085,15.0725 L54.4075,15.0725 L54.4075,21.6065 L51.2095,21.6065 L51.2095,5.2265 L57.6285,5.2265 C60.9645,5.2265 62.9435,7.5045 62.9435,10.2415 C62.9435,12.5425 61.5395,13.9695 59.9525,14.5445 L63.6095,21.6065 L59.9055,21.6065 Z",
    id: "Fill-7",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9616,21.8198 C82.4816,21.8198 80.8466,21.1868 79.3186,19.6348 L79.2676,19.5828 L80.5436,18.3048 L80.5966,18.3568 C81.8726,19.6328 83.0686,20.1068 85.0076,20.1068 C87.3946,20.1068 88.8216,18.9998 88.8216,17.1448 C88.8216,16.2628 88.5666,15.6118 88.0416,15.1528 C87.5576,14.7128 87.1256,14.5508 85.9386,14.3648 L84.0306,14.0888 C82.7026,13.8758 81.7406,13.4748 81.0016,12.8288 C80.1446,12.0678 79.7106,11.0118 79.7106,9.6898 C79.7106,6.8498 81.7986,5.0148 85.0296,5.0148 C87.0746,5.0148 88.5016,5.5398 89.9566,6.8278 L90.0156,6.8798 L88.7816,8.1148 L88.7296,8.0648 C87.6966,7.0788 86.5696,6.6588 84.9616,6.6588 C82.8646,6.6588 81.5616,7.8028 81.5616,9.6438 C81.5616,10.4668 81.8006,11.0908 82.2716,11.4978 C82.7316,11.8948 83.4596,12.1828 84.3756,12.3318 L86.2846,12.6308 C87.8216,12.8638 88.5526,13.1538 89.2896,13.8228 C90.2086,14.6198 90.6956,15.7528 90.6956,17.0988 C90.6956,19.9668 88.4446,21.8198 84.9616,21.8198",
    id: "Fill-8",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8786,16.3105 L101.7876,16.3105 L98.8556,7.9575 L95.8786,16.3105 Z M105.6806,21.6815 L103.6576,21.6815 L103.6406,21.6315 L102.3466,17.9775 L95.2966,17.9775 L93.9856,21.6815 L91.9626,21.6815 L91.9996,21.5815 L98.0456,5.1525 L99.6216,5.1525 L105.6806,21.6815 Z",
    id: "Fill-9",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#4C4C4E",
    mask: "url(#mask-2)",
    points: "120.2785 21.6816 118.5085 21.6816 118.4865 21.6486 109.9265 8.7166 109.9265 21.6816 108.0285 21.6816 108.0285 5.1526 109.7985 5.1526 109.8205 5.1856 118.3815 18.0716 118.3815 5.1526 120.2785 5.1526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6496,19.9687 L130.1416,19.9687 C131.5816,19.9687 132.5876,19.5967 133.3076,18.7967 C134.3696,17.6657 134.3696,15.6017 134.3696,13.4167 C134.3696,11.2327 134.3696,9.1687 133.3086,8.0387 L133.3076,8.0377 C132.5876,7.2377 131.5816,6.8657 130.1416,6.8657 L126.6496,6.8657 L126.6496,19.9687 Z M130.4406,21.6817 L124.7526,21.6817 L124.7526,5.1527 L130.4406,5.1527 C132.3116,5.1527 133.6956,5.7087 134.7966,6.9017 C136.2666,8.4877 136.2666,10.8827 136.2666,13.4167 C136.2666,15.9527 136.2666,18.3467 134.7966,19.9317 C133.6956,21.1247 132.3116,21.6817 130.4406,21.6817 L130.4406,21.6817 Z",
    id: "Fill-11",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#4C4C4E",
    mask: "url(#mask-2)",
    points: "150.3903 21.6816 140.1183 21.6816 140.1183 5.1526 142.0153 5.1526 142.0153 19.9686 150.3903 19.9686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#4C4C4E",
    mask: "url(#mask-2)",
    points: "163.5021 21.6816 153.1841 21.6816 153.1841 5.1526 163.5021 5.1526 163.5021 6.8656 155.0821 6.8656 155.0821 12.4916 162.2601 12.4916 162.2601 14.2046 155.0821 14.2046 155.0821 19.9686 163.5021 19.9686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7687,12.7216 L173.0657,12.7216 C175.0647,12.7216 176.2577,11.6316 176.2577,9.8056 C176.2577,7.9646 175.0647,6.8656 173.0657,6.8656 L168.7687,6.8656 L168.7687,12.7216 Z M178.5257,21.6816 L176.3097,21.6816 L172.5827,14.4116 L168.7687,14.4116 L168.7687,21.6816 L166.8717,21.6816 L166.8717,5.1526 L173.2267,5.1526 C176.2207,5.1526 178.1557,6.9696 178.1557,9.7826 C178.1557,12.0776 176.8387,13.7326 174.6267,14.2286 L178.5257,21.6816 Z",
    id: "Fill-14",
    fill: "#4C4C4E",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#4196B4",
    mask: "url(#mask-2)",
    points: "70.09 26.833 72.563 26.833 72.563 -3.55271368e-15 70.09 -3.55271368e-15"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bcbd3e7caf22b4b74d85dd1870a6d781.svg";
export { ForwardRef as ReactComponent };